import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../../ThemeProvider';
import Background from '../../../components/Background/Background';
import generateEventData from '../generate-event-data';
import Keycap from './Keycap/Keycap';
import classes from './Header.styles.less';
function getPressedKeys(event) {
    const keys = [];
    event.shiftKey && keys.push('Shift');
    event.ctrlKey && keys.push('Ctrl');
    event.altKey && keys.push('Alt');
    event.metaKey && keys.push('Cmd');
    event.code && keys.push(event.key);
    return keys;
}
export default function Header({ event }) {
    const [theme] = useTheme();
    if (!event) {
        return (_jsx(Background, { className: cx(classes.wrapper, classes[theme]), children: _jsxs("div", { className: classes.placeholder, children: [_jsx("h1", { className: classes.title, children: "Press any key to get JavaScript event keycode info" }), _jsxs("p", { className: classes.description, children: [_jsx("b", { children: "Tip:" }), " shift, control, alt and meta (cmd) keys are also captured, you can generate usage with these keys combinations"] })] }) }));
    }
    const data = generateEventData(event);
    const pressedKeys = getPressedKeys(data).map((key, index, arr) => (_jsxs("div", { className: classes.key, children: [_jsx(Keycap, { value: key }, key), index !== arr.length - 1 && _jsx("span", { className: classes.separator, children: "+" })] }, key)));
    return (_jsxs(Background, { className: cx(classes.wrapper, classes[theme]), children: [_jsx("div", { className: classes.keys, children: pressedKeys }), _jsxs("p", { className: classes.description, children: [_jsx("b", { children: "Tip:" }), " shift, control, alt and meta (cmd) keys are also captured, you can generate usage with these keys combinations"] })] }));
}
